import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { EchartService } from '../../../../core/services/echart.service';
import { ToastrService } from 'ngx-toastr';
import { graphic } from 'echarts';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})

export class TimelineComponent implements OnInit, AfterViewInit {
  @ViewChild('myCharts') myCharts: ElementRef;
  @Input() projectId: any;
  selectedYear = 2021;
  echartsInstance: any;


  years = [
    {
      value: 2021,
      desc: 'Year 2021'
    }, {
      value: 2020,
      desc: 'Year 2020'
    }, {
      value: 2019,
      desc: 'Year 2019'
    },
    {
      value: 2018,
      desc: 'Year 2018'
    },
    {
      value: 2017,
      desc: 'Year 2017'
    },
    {
      value: 2016,
      desc: 'Year 2016'
    },
    {
      value: 2015,
      desc: 'Year 2015'
    },
  ];


  reserved = [6, 11, 9, 14, 10, 8, 12, 15, 4, 6, 7, 10, 11];
  sold = [5, 9, 13, 5, 6, 6, 11, 10, 11, 9, 14, 10, 8];
  chartOption = {
    grid: {
      top: '120px',
      right: '40px',
      left: '40px',
      bottom: '60px'
    },
    color: ['#5121d3', '#05CD99'],
    title: {
      text: 'Monthly Property Stats',
      top: '30px',
      left: '20px',
      textStyle: {
        fontFamily: 'Roboto',
        fontSize: 10
      }
    },
    legend: {
      data: ['Sold', 'Settled'],
      left: '20px',
      top: '60px',
      textStyle: {
        color: '#a3a3a3'
      }
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      offset: 2,
      data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      axisLine: {
        show: false
      },
      axisLabel: {
        color: '#cccccc',
        fontFamily: 'Poppins Regular'
      },
      axisTick: {
        show: false
      },
    },
    yAxis: {
      interval: '5',
      minInterval: '5',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#cccccc',
        fontFamily: 'Poppins Regular'
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#eaeaea',
          dashOffset: '5'
        }
      }
    },
    series: [
      {
        name: 'Sold',
        smooth: true,
        symbol: 'circle',
        data: [],
        type: 'line',
        lineStyle: {
          color: '#5121d3'
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(81,33,211,0.59)'
          }, {
            offset: 1,
            color: 'rgba(81,33,211,0.18)'
          }])
        },
      },
      {
        name: 'Settled',
        smooth: true,
        symbol: 'circle',
        data: [],
        type: 'line',
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#05CD99'
          }, {
            offset: 1,
            color: 'rgba(5,205,153,0.04)'
          }])
        },
        lineStyle: {
          color: '#05CD99'
        }
      }
    ]
  };

  constructor(private echartService: EchartService, private toastrService: ToastrService) {
    this.selectedYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    // this.echartService.getDate('2018', this.projectId).subscribe((res: any) => {
    //   console.log(res);
    // });

  }

  ngAfterViewInit(): void {
    // console.log(new Date().getFullYear())
    this.selectYear(this.selectedYear);
  }

  selectYear(e) {
    console.log(e);
    this.echartService.getDate(e, this.projectId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        // const sold = [];
        // const settle = [];
        this.chartOption.series[0].data = [];
        this.chartOption.series[1].data = [];
        for (const k in res.data.sold) {
          // sold.push(res.data.sold[k]);
          this.chartOption.series[0].data.push(res.data.sold[k]);
        }
        for (const k in res.data.settle) {
          // settle.push(res.data.settle[k]);
          this.chartOption.series[1].data.push(res.data.settle[k]);
        }
        if (this.echartsInstance) {
          this.echartsInstance.setOption(this.chartOption);
        }
      } else {
        // this.toastrService.warning('Sorry, failed to get data');
      }
    });
  }

  onChartInit(ec) {
    console.log(ec);
    // ec.resize();
    this.echartsInstance = ec;
  }
}
